"use strict";
import Choices from "./Choices";
import {telemetry} from "../../telemetry/telemetry";

const vm = require("vm");
const extend = require("extend");


class Choice {

    private _choices: Choices;
    private _choiceId: string;

    constructor(choices, choiceId) {
        this._choices = choices;
        this._choiceId = choiceId;
    }

    get id() {
        return this._choiceId;
    }

    get sortKey() {
        return this._choice.sortKey || this.id;
    }

    get storeValue() {
        if ("store" in this._choice) {
            return ("v" in this._choice.store) ? this._choice.store.v : null;
        }
        return this.id;
    }

    get displayValue() {
        if ("display" in this._choice) {
            return ("v" in this._choice.display) ? this._choice.display.v : null;
        }
        return this.id;
    }

    displayValueWithContext(evalContext = {}) {
        const rawDisplayValue = this.displayValue;

        if (rawDisplayValue.indexOf(";") === -1) return rawDisplayValue;

        try {
            //extending so that expression may not modify things in the context.
            const context = vm.createContext(extend(true, {}, evalContext));
            const result = vm.runInContext(rawDisplayValue, context);
            return result;
        } catch (err) {
            telemetry.error("Error evaluating display value for choice: " + this.id);
            telemetry.error(err);
            return "";
        }
    }

    get _choice() {
        return this._choices._getRawChoice(this.id);
    }

    toString() {
        return `${this.id}(${this.storeValue}, ${this.displayValue}, ${this.sortKey})`;
    }

    changeDisplayValueTo(displayValue) {
        const RAWChoice = {
            display: { v: displayValue },
            storeValue: this.storeValue
        };
        return this._choices._questions._qWriteRawCustomQuestionChoice(this._choices.questionId, this.id, RAWChoice);
    }

    remove() {
        return this._choices._questions._qWriteRawCustomQuestionChoice(this._choices.questionId, this.id, null);
    }
}

export default Choice;
